import { stripTrailingSlash } from "../lib/helpers";
import config from "./config";

export const cityGeolocations = [
  {
    name: {
      ar: "عرعر",
      en: "Arar",
    },
    lat: 30.9599447,
    lng: 41.0595636,
    display_lat: 29.7248676,
    display_lng: 42.4362435,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/6.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/6.png`,
  },
  {
    name: {
      ar: "الجوف",
      en: "Jawf",
    },
    lat: 29.9254899,
    lng: 40.1862129,
    display_lat: 29.887356,
    display_lng: 39.0206241,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/4.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/4.png`,
  },
  {
    name: {
      ar: "تبوك",
      en: "Tabuk",
    },
    lat: 28.3833333,
    lng: 36.5833333,
    display_lat: 27.5833333,
    display_lng: 37.3833333,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/5.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/5.png`,
  },
  {
    name: {
      ar: "حائل",
      en: "Ha'il",
    },
    lat: 27.5166667,
    lng: 41.6833333,
    display_lat: 27.5166667,
    display_lng: 41.6833333,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/7.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/7.png`,
  },
  {
    name: {
      ar: "القصيم",
      en: "Qassim",
    },
    lat: 26.3333333,
    lng: 43.9666667,
    display_lat: 25.051471,
    display_lng: 42.8637875,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/8.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/8.png`,
  },
  {
    name: {
      ar: "الرياض",
      en: "Riyadh",
    },
    lat: 24.7116667,
    lng: 46.7241667,
    display_lat: 24.7116667,
    display_lng: 46.7241667,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/9.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/9.png`,
  },
  {
    name: {
      ar: "المدينة",
      en: "Madinah",
    },
    lat: 24.4666667,
    lng: 39.6,
    display_lat: 24.4666667,
    display_lng: 39.6 - 0.6,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/1.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/1.png`,
  },
  {
    name: {
      ar: "عسير",
      en: "Asir",
    },
    lat: 18.2465,
    lng: 42.5117,
    display_lat: 18.9969062,
    display_lng: 43.9637875,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/14.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/14.png`,
  },
  {
    name: {
      ar: "باحة",
      en: "Bahah",
    },
    lat: 20,
    lng: 41.45,
    display_lat: 19.6,
    display_lng: 41.45,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/13.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/13.png`,
  },
  {
    name: {
      ar: "جيزان",
      en: "Jizan",
    },
    lat: 16.8833333,
    lng: 42.55,
    display_lat: 16.5833333,
    display_lng: 42.55 + 0.6,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/2.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/2.png`,
  },
  {
    name: {
      ar: "مكة",
      en: "Makkah",
    },
    lat: 21.4166667,
    lng: 39.8166667,
    display_lat: 21.8166667 - 0.4,
    display_lng: 40.9166667 + 0.4,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/10.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/10.png`,
  },
  {
    name: {
      ar: "جدة",
      en: "Jeddah",
    },
    lat: 21.4858,
    lng: 39.1925,
    display_lat: 21.9166667 + 0.6,
    display_lng: 38.7166667 + 0.6,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/11.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/11.png`,
  },
  {
    name: {
      ar: "نجران",
      en: "Najran",
    },
    lat: 17.54391,
    lng: 44.222966,
    display_lat: 17.4916667,
    display_lng: 46.17476,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/3.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/3.png`,
  },
  {
    name: {
      ar: "دمام",
      en: "Dammam",
    },
    lat: 26.3926665,
    lng: 49.9777136,
    display_lat: 26.3926665,
    display_lng: 49.9777136 - 0.6,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/15.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/15.png`,
  },
  {
    name: {
      ar: "احساء",
      en: "Ahsa",
    },
    lat: 25.390235,
    lng: 49.559463,
    display_lat: 22.8166667,
    display_lng: 49.559463,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/12.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/12.png`,
  },
];
export const CITIES_BOUNDS_MAP = [
  {
    name: "ابها",
    title: "عقارات في ابها",
    name_en: "Abha",
    uri: "ابها",
    path: "/عقارات/ابها",
    city_id: 1,
    directions: false,
    bounds: {
      northEast: {
        lat: 18.260819999999967,
        lng: 42.56906,
      },
      southWest: {
        lat: 18.18443000000002,
        lng: 42.466640000000005,
      },
    },
    lat: 18.2465,
    lng: 42.5117,
    display_lat: 18.9969062,
    display_lng: 43.9637875,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/14.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/14.png`,
  },
  {
    name: "الباحة",
    title: "عقارات في الباحة",
    name_en: "Al Bahah",
    uri: "الباحة",
    path: "/عقارات/الباحة",
    city_id: 5,
    directions: false,
    bounds: {
      northEast: {
        lat: 20.043699999999944,
        lng: 41.4827,
      },
      southWest: {
        lat: 19.999850000000038,
        lng: 41.4373,
      },
    },
    lat: 20,
    lng: 41.45,
    display_lat: 19.6,
    display_lng: 41.45,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/13.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/13.png`,
  },
  {
    name: "الدمام",
    title: "عقارات في الدمام",
    name_en: "Dammam",
    uri: "الدمام",
    path: "/عقارات/الدمام",
    city_id: 18,

    directions: false,
    bounds: {
      northEast: {
        lat: 26.526489999999967,
        lng: 50.238290000000006,
      },
      southWest: {
        lat: 26.21474999999998,
        lng: 49.75227,
      },
    },
    lat: 26.3926665,
    lng: 49.9777136,
    display_lat: 26.3926665,
    display_lng: 49.9777136 - 0.6,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/15.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/15.png`,
  },
  {
    name: "الرياض",
    title: "عقارات في الرياض",
    name_en: "Riyadh",
    uri: "الرياض",
    path: "/عقارات/الرياض",
    city_id: 21,
    directions: true,
    bounds: {
      northEast: {
        lat: 25.120419999999967,
        lng: 47.05745,
      },
      southWest: {
        lat: 24.311120000000074,
        lng: 46.41664,
      },
    },
    lat: 24.7116667,
    lng: 46.7241667,
    display_lat: 24.7116667,
    display_lng: 46.7241667,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/9.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/9.png`,
  },
  {
    name: "المدينة المنورة",
    title: "عقارات في المدينة المنورة",
    name_en: "Medina",
    uri: "المدينة-المنورة",
    path: "/عقارات/المدينة-المنورة",
    city_id: 41,
    directions: false,
    bounds: {
      northEast: {
        lat: 24.621309999999994,
        lng: 39.723040000000005,
      },
      southWest: {
        lat: 24.34432000000004,
        lng: 39.424400000000006,
      },
    },
    lat: 24.4666667,
    lng: 39.6,
    display_lat: 24.4666667,
    display_lng: 39.6 - 0.6,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/1.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/1.png`,
  },
  {
    name: "الهفوف",
    title: "عقارات في الهفوف",
    name_en: "Al Hofuf",
    uri: "الهفوف",
    path: "/عقارات/الهفوف",
    city_id: 46,
    directions: false,
    bounds: {
      northEast: {
        lat: 25.536319999999932,
        lng: 49.762750000000004,
      },
      southWest: {
        lat: 25.283239999999978,
        lng: 49.50757,
      },
    },
    lat: 25.390235,
    lng: 49.559463,
    display_lat: 22.8166667,
    display_lng: 49.559463,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/12.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/12.png`,
  },
  {
    name: "بريدة",
    title: "عقارات في بريدة",
    name_en: "Buraydah",
    uri: "بريدة",
    path: "/عقارات/بريدة",
    city_id: 52,
    directions: false,
    bounds: {
      northEast: {
        lat: 26.439139999999952,
        lng: 44.08565,
      },
      southWest: {
        lat: 26.204849999999965,
        lng: 43.80747,
      },
    },

    lat: 26.3333333,
    lng: 43.9666667,
    display_lat: 25.051471,
    display_lng: 42.8637875,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/8.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/8.png`,
  },
  {
    name: "تبوك",
    title: "عقارات في تبوك",
    name_en: "Tabuk",
    uri: "تبوك",
    path: "/عقارات/تبوك",
    city_id: 59,
    directions: false,
    bounds: {
      northEast: {
        lat: 28.573370000000068,
        lng: 36.88248,
      },
      southWest: {
        lat: 28.352640000000065,
        lng: 36.468270000000004,
      },
    },
    lat: 28.3833333,
    lng: 36.5833333,
    display_lat: 27.5833333,
    display_lng: 37.3833333,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/5.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/5.png`,
  },
  {
    name: "عرعر",
    title: "عقارات في عرعر",
    name_en: "Arar",
    uri: "عرعر",
    path: "/عقارات/عرعر",
    city_id: 88,
    directions: false,
    bounds: {
      northEast: {
        lat: 31.01685999999995,
        lng: 41.064490000000006,
      },
      southWest: {
        lat: 30.951389999999947,
        lng: 40.97424,
      },
    },
    lat: 30.9599447,
    lng: 41.0595636,
    display_lat: 29.7248676,
    display_lng: 42.4362435,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/6.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/6.png`,
  },
  {
    name: "جازان",
    title: "عقارات في جازان",
    name_en: "Jazan",
    uri: "جازان",
    path: "/عقارات/جازان",
    city_id: 65,
    directions: false,
    bounds: {
      northEast: {
        lat: 16.974379999999996,
        lng: 42.740770000000005,
      },
      southWest: {
        lat: 16.821750000000065,
        lng: 42.537560000000006,
      },
    },
    lat: 16.8833333,
    lng: 42.55,
    display_lat: 16.5833333,
    display_lng: 42.55 + 0.6,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/2.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/2.png`,
  },
  {
    name: "جدة",
    title: "عقارات في جدة",
    name_en: "Jeddah",
    uri: "جدة",
    path: "/عقارات/جدة",
    city_id: 66,
    directions: true,
    bounds: {
      northEast: {
        lat: 21.89623000000006,
        lng: 39.4665,
      },
      southWest: {
        lat: 21.096670000000017,
        lng: 39.02769,
      },
    },

    lat: 21.4858,
    lng: 39.1925,
    display_lat: 21.9166667 + 0.6,
    display_lng: 38.7166667 + 0.6,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/11.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/11.png`,
  },
  {
    name: "حائل",
    title: "عقارات في حائل",
    name_en: "Hail",
    uri: "حائل",
    path: "/عقارات/حائل",
    city_id: 67,
    directions: false,
    bounds: {
      northEast: {
        lat: 27.649740000000065,
        lng: 41.82791,
      },
      southWest: {
        lat: 27.44605999999999,
        lng: 41.601710000000004,
      },
    },
    lat: 27.5166667,
    lng: 41.6833333,
    display_lat: 27.5166667,
    display_lng: 41.6833333,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/7.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/7.png`,
  },
  {
    name: "سكاكا",
    title: "عقارات في سكاكا",
    name_en: "Sakaka",
    uri: "سكاكا",
    path: "/عقارات/سكاكا",
    city_id: 79,
    directions: false,
    bounds: {
      northEast: {
        lat: 30.025370000000066,
        lng: 40.267050000000005,
      },
      southWest: {
        lat: 29.845969999999966,
        lng: 40.14645,
      },
    },
    lat: 29.9254899,
    lng: 40.1862129,
    display_lat: 29.887356,
    display_lng: 39.0206241,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/4.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/4.png`,
  },
  {
    name: "مكة المكرمة",
    title: "عقارات في مكة المكرمة",
    name_en: "Mecca",
    uri: "مكة-المكرمة",
    path: "/عقارات/مكة-المكرمة",
    city_id: 94,
    directions: false,
    bounds: {
      northEast: {
        lat: 21.62751000000003,
        lng: 40.03598,
      },
      southWest: {
        lat: 21.229060000000004,
        lng: 39.60228,
      },
    },

    lat: 21.4166667,
    lng: 39.8166667,
    display_lat: 21.8166667 - 0.4,
    display_lng: 40.9166667 + 0.4,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/10.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/10.png`,
  },
  {
    name: "نجران",
    title: "عقارات في نجران",
    name_en: "Najran",
    uri: "نجران",
    path: "/عقارات/نجران",
    city_id: 96,
    directions: false,
    bounds: {
      northEast: {
        lat: 17.601319999999987,
        lng: 44.375240000000005,
      },
      southWest: {
        lat: 17.40576999999996,
        lng: 44.08174,
      },
    },

    lat: 17.54391,
    lng: 44.222966,
    display_lat: 17.4916667,
    display_lng: 46.17476,
    icon: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/3.svg`,
    icon_png: `${stripTrailingSlash(config.ICONS_BASE_URL)}/regions/3.png`,
  },
];

export const saudiPolygon = [
  [33.938126330156024, 28.28296016364755],
  [41.936173205156024, 15.260717381347503],
  [50.373673205156024, 17.453226776690887],
  [55.735001330156024, 19.867845778253017],
  [56.350235705156024, 22.408852111432076],
  [55.383438830156024, 23.299738931513662],
  [52.746720080156024, 23.783190547579743],
  [50.725235705156024, 25.381608317920175],
  [50.461563830156024, 27.272068628712223],
  [48.703751330156024, 29.05411177283789],
  [45.627579455156024, 29.43754733398371],
  [41.320938830156024, 32.229398220976],
  [38.947891955156024, 32.674391141555304],
  [36.311173205156024, 31.48288575605923],
  [37.190079455156024, 30.57915248422117],
  [35.783829455156024, 29.89576469642768],
  [34.641251330156024, 30.50345554521471],
  [33.674454455156024, 28.900336237555543],
];
